const studentDashboardUrl = '/student-dashboard';

export default studentDashboardUrl;
